// pubkey self
import selfHtml from './s33-privkey_link_device_qr.html' with { type: 'text' };

import { mod_loader, PrivKeyLinkQRModule, db_PrivateKeyPair, BASEURL } from "../AppState.js";

import { copy_to_clipboard, navbar_active_menu, generate_qr, postData, secondsToHuman, show_modal } from '../utils.js';

import { encrypt_gpg, get_pub_key, generateSecureString } from "../crypt_helper.js"

var root
var ttl_validity = 0;
var timer = null;

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root

    navbar_active_menu(".navbar_link_device_qr")

    root.querySelector(".copy_link_to_clipboard").addEventListener('click', (e) => copy_to_clipboard(e.currentTarget));

    root.querySelector(".btn_privkey_link_QR").addEventListener('click', async (ev) => {

        const my_pubkey = await get_pub_key();

        if (my_pubkey == null)
            return show_modal("Cannot link device", "You are trying to link another device, but your account has no public key yet.");

        $e(root).getEl("QR_link_loading_spinner").classList.remove("d-none");

        const QR_PrivKey_Panel = $e(root).getEl("QR_PrivKey_Panel");
        QR_PrivKey_Panel.innerHTML = "";
        $e(root).getEl("URL_PrivKey_Panel").value = "..."

        $e(root).getEl("Link_Panel").classList.remove("d-none");
        const PrivateKeyPair = await db_PrivateKeyPair.get('keyPair');
        const a = JSON.stringify(PrivateKeyPair);
        const payload_cleartext = {};
        payload_cleartext.type = "link-device";
        payload_cleartext.PrivateKeyPair = PrivateKeyPair;
        const psk_password = generateSecureString(22);
        const enc = await encrypt_gpg(JSON.stringify(payload_cleartext), psk_password, []);

        const payload = {
            armoured_text: enc,
            pgp_pub_rcpt: null,
            ttl: "5m", // DEBUG: "2w", PROD: "5m",
            pgp_pubkey: my_pubkey.myKeyPairPublicKey,
            autodestruct: true,
            notify_sender_on_intended: false,
            notify_sender_on_fail: false,
        }

        const data = await postData(BASEURL.api + '/post_note', payload, ev.target);

        const url_encrypted_link = BASEURL.www + "/?id=" + data.hash + "#" + psk_password;

        generate_qr(url_encrypted_link, QR_PrivKey_Panel, "#ac0418");
        $e(root).getEl("URL_PrivKey_Panel").value = url_encrypted_link

        $e(root).getEl("QR_link_loading_spinner").classList.add("d-none");

        ttl_validity = 5 * 60;
        if (timer) clearTimeout(timer);
        update_ttl();

    });

    function update_ttl() {
        $e(root).getEl("QR_validity_countdown").innerText = secondsToHuman(ttl_validity--);
        timer = setTimeout(() => { update_ttl(); }, 1000);
    }
}
